import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';

enum Tabs {
  record = 'Historial Alerta',
  comments = 'Comentarios',
  files = 'Archivos',
}
@Component({
  selector: 'alert-record',
  templateUrl: './alert-record.component.html',
  styleUrls: ['./alert-record.component.scss']
})
export class AlertRecordComponent implements OnInit {

  public Tabs = Tabs;

  @Input() view: boolean = false;
  @Output() hidden = new EventEmitter<boolean>();

  selected: Tabs = Tabs.record;

  constructor() {}

  ngOnChanges() {
    if (this.view) {
      console.log(' ');
    }
  }

  ngOnInit(): void {}

  clickHidden() {
    this.hidden.emit(false);
  }

}
